module.exports = __webpack_public_path__ + "logo.png?51c38648c4ed28febf4ef4f7bec32ce4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 41
// module chunks = 0